import React, { useState } from 'react';
import { Modal, Button, Input, message, Radio } from 'antd';
import {
  ModalBody,
  InputLabel,
  Container,
  InputContainer,
  ModalContainer,
  InputRow,
  AdduserSec,
  WarningLabel,
} from './styles';
import REGEX from '../../utils/regex';
import { createSMTPConfig, updateSMTPConfig } from '../../utils/services/smtpConfigAPI';
import { withTranslation } from 'react-i18next';
import { ADD_OR_UPDATE_SMTP_SERVER_MODAL } from '../../containers/UserSettingsPage/TranslationValues';

const NAMESPACE = ['ADD_OR_UPDATE_SMTP_SERVER_MODAL'];
const SMTPConfigModal = props => {
  const { onCancel, onSuccess, isEditing, target, t } = props;
  const [loading, setLoading] = useState(false);
  const { userName, password, fromAddress, port, hostName, protocol, id } = target;
  const [Validmail, setValidmail] = useState(isEditing);
  const [activeOption, setActiveOption] = useState(protocol ? protocol : 'SSL');
  const [smtpDetails, setSMTPDetails] = useState({
    id,
    userName,
    password,
    fromAddress,
    port: port ? port : activeOption === 'SSL' ? '465' : '587',
    hostName,
    protocol: activeOption,
  });
  const [warningText, setWarningText] = useState({
    userName: '',
    password: '',
    fromAddress: '',
    port: '',
    hostName: '',
    overAllIssue: '',
  });
  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      if (
        smtpDetails.userName &&
        smtpDetails.fromAddress &&
        Validmail &&
        smtpDetails.password &&
        smtpDetails.port &&
        smtpDetails.hostName
      ) {
        onSave();
      }
    }
  };

  const handleChange = e => {
    const { value, name } = e.target;
    setSMTPDetails({ ...smtpDetails, [name]: value });
    if (name === 'fromAddress') {
      if (value.length > 0) {
        validateEmail(value);
      } else {
        setWarningText({
          ...warningText,
          fromAddress: value.length > 0 ? '' : t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE.value),
        });
      }
    }
  };

  const validateEmail = value => {
    let trimedTag = value.trim().replace(/\s/g, '');
    if (trimedTag.length > 0) {
      const isValidEmail = REGEX.EMAIL.test(trimedTag);
      setWarningText({
        ...warningText,
        fromAddress: !isValidEmail ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.INVALID_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.INVALID_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE.value) : '',
      });
      setValidmail(isValidEmail);
    }
  };

  const onSave = async () => {
    setLoading(true);
    let response;
    let payload = smtpDetails;
    if (!isEditing) {
      response = await createSMTPConfig(payload);
    } else {
      payload.default = target.default;
      response = await updateSMTPConfig(payload);
    }
    if (response) {
      setLoading(false);
      if (response && response.errors && response.errors.length === 0) {
        let responseType = isEditing
        ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.UPDATE_SMTP_SERVER_SUCCESS_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.UPDATE_SMTP_SERVER_SUCCESS_MESSAGE.value)
        : t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.ADD_NEW_SMTP_SERVER_SUCCESS_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.ADD_NEW_SMTP_SERVER_SUCCESS_MESSAGE.value);
      message.success(responseType);
        onSuccess();
        onCancel();
      } else {
        setWarningText({
          ...warningText,
          overAllIssue:
            response.errors[0].code === 901
            ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.INVALID_SMTP_SERVER_CREDENTIALS_ERROR_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.INVALID_SMTP_SERVER_CREDENTIALS_ERROR_MESSAGE.value)
            : response.errors[0].code === 902
            ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_NOT_FOUND_ERROR_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_NOT_FOUND_ERROR_MESSAGE.value)
            : response.errors[0].code === 903
            ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.UNREACHABLE_SMTP_SERVER_MESSAGING_EXCEPTION_ERROR_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.UNREACHABLE_SMTP_SERVER_MESSAGING_EXCEPTION_ERROR_MESSAGE.value)
            : response.errors[0].code === 919
            ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.USER_OR_FROM_ADDRESS_ALREADY_EXIST_WARNING_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.USER_OR_FROM_ADDRESS_ALREADY_EXIST_WARNING_MESSAGE.value)
            : '',
        });
      }
    }
  };

  const validateDetails = () => {
    if (
      smtpDetails.userName &&     
      smtpDetails.password &&
      smtpDetails.port &&
      smtpDetails.hostName
    ) {
      onSave();
    } else {
      setWarningText({
        ...warningText,
        userName: !smtpDetails.userName ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_USERNAME_WARNING_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_USERNAME_WARNING_MESSAGE.value) : '',
        password: !smtpDetails.password ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_PASSWORD_WARNING_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_PASSWORD_WARNING_MESSAGE.value) : '',
        fromAddress: !smtpDetails.fromAddress ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_FROM_ADDRESS_WARNING_MESSAGE.value) : '',
        port: !smtpDetails.port ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_HOST_WARNING_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_HOST_WARNING_MESSAGE.value) : '',
        hostName: !smtpDetails.hostName ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_PORT_WARNING_MESSAGE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.EMPTY_SMTP_SERVER_PORT_WARNING_MESSAGE.value) : '',
      });
    }
  };

  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div>{isEditing ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.EDIT_SMTP_SERVER_MODAL_TITLE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.EDIT_SMTP_SERVER_MODAL_TITLE.value) : t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.ADD_SMTP_SERVER_MODAL_TITLE.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.ADD_SMTP_SERVER_MODAL_TITLE.value)}</div>
            <WarningLabel allIssue={1}>{warningText.overAllIssue} </WarningLabel>
          </div>
        }
        visible={true}
        maskClosable={false}
        width={1000}
        centered
        onCancel={onCancel}
        footer={[
          <Button
            key="Add User"
            type="primary"
            // disabled={}
            loading={loading}
            onClick={validateDetails}
          >
            {isEditing ? t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.UPDATE_SMTP_SERVER_BUTTON.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.UPDATE_SMTP_SERVER_BUTTON.value) : t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.ADD_NEW_SMTP_SERVER_BUTTON.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.ADD_NEW_SMTP_SERVER_BUTTON.value)}
          </Button>,
        ]}
      >
        <ModalBody>
          <AdduserSec style={{ width: '100%' }}>
            <ModalContainer user={1}>
              <InputRow>
                <InputContainer className="full-width" user={1}>
                  <InputLabel>{t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_HOST_LABEL.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_HOST_LABEL.value)}</InputLabel>
                  <Input
                    size="large"
                    placeholder={t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_HOST_PLACEHOLDER.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_HOST_PLACEHOLDER.value)}
                    name="hostName"
                    value={smtpDetails.hostName}
                    onChange={handleChange}
                    autoComplete={'off'}
                  />
                  <WarningLabel>{!smtpDetails.hostName && warningText.hostName} </WarningLabel>
                </InputContainer>
                <InputContainer className="full-width" user={1}>
                  <InputLabel>{t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PORT_LABEL.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PORT_LABEL.value)}</InputLabel>
                  <Input
                    size="large"
                    placeholder={t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PORT_PLACEHOLDER.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PORT_PLACEHOLDER.value)}
                    name="port"
                    value={smtpDetails.port}
                    onChange={handleChange}
                    autoComplete={'off'}
                  />
                  <WarningLabel>{!smtpDetails.port && warningText.port}</WarningLabel>
                </InputContainer>
              </InputRow>           
              <InputRow>
                <InputContainer className="full-width" user={1}>
                  <InputLabel>{t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_USERNAME_LABEL.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_USERNAME_LABEL.value)}</InputLabel>
                  <Input
                    size="large"
                    placeholder={t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_USERNAME_PLACEHOLDER.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_USERNAME_PLACEHOLDER.value)}
                    name="userName"
                    value={smtpDetails.userName}
                    onChange={handleChange}
                    autoComplete={'off'}
                  />
                  <WarningLabel>{!smtpDetails.userName && warningText.userName}</WarningLabel>
                </InputContainer>
                <InputContainer className="full-width" user={1}>
                  <InputLabel>{t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PASSWORD_LABEL.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PASSWORD_LABEL.value)}</InputLabel>
                  <Input.Password
                    size="large"
                    placeholder={t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PASSWORD_PLACEHOLDER.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PASSWORD_PLACEHOLDER.value)}
                    name="password"
                    value={smtpDetails.password}
                    onChange={handleChange}
                    autoComplete={'off'}
                  />
                  <WarningLabel>{!smtpDetails.password && warningText.password} </WarningLabel>
                </InputContainer>
              </InputRow>

              <InputContainer className="full-width" user={1}>
                  <InputLabel>{t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PROTOCOL_LABEL.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PROTOCOL_LABEL.value)}</InputLabel>
                  <Radio.Group
                    onChange={e => {
                      setActiveOption(e.target.value);
                      setSMTPDetails({
                        ...smtpDetails,
                        port: e.target.value === 'SSL' ? '465' : '587',
                        protocol: e.target.value,
                      });
                    }}
                    value={activeOption}
                  >
                    <Radio value={'SSL'}>{t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PROTOCOL_SSL_RADIO_BUTTON.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PROTOCOL_SSL_RADIO_BUTTON.value)}</Radio>
                    <Radio value={'TLS'}>{t(ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PROTOCOL_TLS_RADIO_BUTTON.key, ADD_OR_UPDATE_SMTP_SERVER_MODAL.SMTP_SERVER_PROTOCOL_TLS_RADIO_BUTTON.value)}</Radio>
                  </Radio.Group>
                </InputContainer>
            </ModalContainer>
          </AdduserSec>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(NAMESPACE)(SMTPConfigModal);
